<template>
  <div id="index">
    <div class="bottombox">
      <Header ref="header" />
    </div>
    <!-- bottombox end -->
    <div class="search_tab">
      <div class="search_Text w1200">
        和 "{{keyword}}" 相关的内容
      </div>
      <div class="search_tab_c w1200">
        <router-link :to="{path:'/search',query:{keyword:keyword}}"><span :class="{'side': num == 0}">全部</span>
        </router-link>
        <router-link :to="{path:'/search_course',query:{keyword:keyword}}"><span :class="{'side': num == 1}">课程</span>
        </router-link>
        <router-link :to="{path:'/search_TestPaper',query:{keyword:keyword}}"><span
            :class="{'side': num == 2}">练习-套卷</span>
        </router-link>
        <router-link :to="{path:'/search_Section',query:{keyword:keyword}}"><span
            :class="{'side': num == 3}">练习-单项</span>
        </router-link>
        <!-- <router-link :to="{path:'/search_languageTest',query:{keyword:keyword}}"><span
            :class="{'side': num == 4}">全真模考</span></router-link> -->
      </div>
    </div>
    <div class="main w1200">
      <div class="search_null" v-if="KPTestsSectionNum==0">
        <img src="../../assets/courselist/search.png" alt="" class="wuImg">
        <p>没有你要找的内容，可以换个关键词试试</p>
      </div>
      <div class="search_main KPTestsSection_main" v-else>
        <!-- <div class="search_con">课程找到{{courseArrNum}}条结果
        </div> -->
        <ul class="clearfix">
          <li v-for="item,index in KPTestsSection" class="other_item" :key="index">
            <div class="answer_box">
              <div v-if="item.AnswerSectionId" class="score_div" @click.stop="todetail2(item,99)">
                上次结果
              </div>
              <div v-else>未作答</div>
            </div>
            <div class="name_box">{{ "· " + item.Title }}</div>
            <div class="questions_count" v-if="!item.Unfinished">
              <div>题量：</div>
              <div class="gray">共{{ item.QuestionCount }}题</div>
            </div>
            <div v-if="item.Unfinished&&item.QuestionCount-0>1&&[8,28].indexOf(item.SubjectType)==-1" class="df_view">
              <div class="btn_status btn_status_1" @click="todetail2(item,3)">继续答题</div>
              <div class="btn_status btn_status_2" @click="todetail2(item,1)">重新答题</div>
            </div>
            <div class="btn_status_3" v-else @click="todetail2(item,2)">
              <img src="../../assets/practiceSystem/icon01.png">
            </div>
          </li>
        </ul>
        <div class="block">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="currentPage" :page-size="12" :total="total" background
            layout="total,prev, pager, next, jumper,->">
          </el-pagination>
        </div>
        <!-- block end -->
      </div>
    </div>
    <cdkey-modal ref="CDKModal">
      <template #modalMIddle>
        <div class="cdk_modal_main">
          <img
            src="@/assets/practiceSystem/modal_close.png"
            class="modal_close_icon"
            alt=""
            @click="modalClose"
          />
          <img
            src="@/assets/practiceSystem/cdk_modal_img.png"
            class="modal_img"
            alt=""
          />
          <div class="tips_modal">请联系您的留学/考培顾问，获取试卷兑换码</div>
          <div class="btn_modal" @click="modalClose">确定</div>
        </div>
      </template>
    </cdkey-modal>
  </div>
</template>

<script>
  import Header from '../../components/header/Header.vue'; //公共头部
  import cdkeyModal from "@/components/modal/cdkeyModal";
  export default {
    components: {
      // 将组件隐射为标签,登陆弹窗
      Header,cdkeyModal
    },
    metaInfo() {
      return {
        title: '启德考培在线',
        meta: [{
            name: "keywords",
            content: "启德考培在线,启德考培在线课程,雅思在线课程,托福在线课程"
          },
          {
            name: "description",
            content: "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
          },
        ],
      };
    },
    data() {
      return {
        tokenkey: "",
        pageTypeId: 13, //首页banner图
        num: 3,
        listBox: [], //列表盒子
        limit: 12,
        currentPage: 1,
        keyword: '',
        KPTestsSection: [],
        KPTestsSectionNum: 0,
        total: 0, //总条数
      }
    },
    created() { //自动触发写入的函数
      let that = this
      that.keyword = that.$route.query.keyword
      this.tokenkey = this.$cookies.get("token");
      // 课程
      that.getKPTestsSection(that.currentPage, that.limit, that.keyword)
    },
    methods: {
      modalClose() {
      this.$refs.CDKModal.close();
    },
      iconShrink() {
        this.screenup = true
      },
      iconOpen() {
        this.screenup = false
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        let that = this;
        // console.log(`当前页: ${val}`);
        that.currentPage = val
        that.getKPTestsSection(that.currentPage, that.limit, that.keyword)
      },
      getKPTestsSection(currentPage, limit, keyword) {
        let that = this;
        this.$api.get('https://schoolapi.eiceducation.com.cn/api/KPTestsSection?page=' + currentPage + '&limit=' +
          limit + '&keyword=' + keyword, '',
          (res) => {
            console.log(res, '练习-专项')
            if (res.data.code == 200) {
              that.KPTestsSectionNum = res.data.count;
              that.KPTestsSection = res.data.results
              that.total = res.data.count;
            }
          })
      },
      judgeIsAnswer() {
      let flag = false;
      if (this.$store.state.userInfo.Type == 2) {
        flag = true;
      } else if (
        this.$store.state.userInfo.VipList &&
        this.$store.state.userInfo.VipList.some(item1 => item1.VipType == 1)
      ) {
        flag = true;
      }
      return flag;
    },
      async todetail2(itemData, restart) {
        if (this.tokenkey) {
        if (!itemData.IsPublic && !this.judgeIsAnswer()) {
          this.$refs.CDKModal.open();
          return;
        }
        this.$utils.gatAllNavUrl({
          ...itemData,
          paperId: itemData.Id,
          restart,
          a_flag: restart == 99 ? 2 : 1,
          a_type: 2,
          transcript:itemData.AnswerSectionId,
        });
        // let { CourseType, SubjectType } = this;
        // // TODO
        // //改域名
        // let baseUrl = this.$utils.getWindowNavUrl(1);
        // console.log(baseUrl, "baseUrl");
        // let url = "";
        // if (itemData.CourseType == 3) {
        //   if (String(itemData.SubjectType) && itemData.SubjectType == -1) {
        //     url = `${baseUrl}/progress?testPaperId=${itemData.Id}&is_clear_storge=1`;
        //   } else if (
        //     String(itemData.SubjectType) &&
        //     itemData.SubjectType != -1
        //   ) {
        //     switch (parseInt(itemData.SubjectType)) {
        //       case 28: //听力
        //         url = `${baseUrl}/progress?sectionId=${itemData.Id}&subject_type=28&is_clear_storge=1`;
        //         break;
        //       case 27: //阅读
        //         url = `${baseUrl}/progress?sectionId=${itemData.Id}&subject_type=27&is_clear_storge=1`;
        //         break;
        //       case 30: //写作
        //         url = `${baseUrl}/progress?sectionId=${itemData.Id}&subject_type=30&is_clear_storge=1`;
        //         break;
        //       case 29: //口语
        //         url = `${baseUrl}/progress?sectionId=${itemData.Id}&subject_type=29&is_clear_storge=1`;
        //         break;
        //     }
        //   }
        // } else if (itemData.CourseType == 4) {
        //   baseUrl = this.$utils.getWindowNavUrl(3);
        //   url = `${baseUrl}/progress?id=${itemData.Id}&type=${
        //     itemData.SubjectType == -1 ? "test" : "section"
        //   }`;
        // } else if (itemData.CourseType == 2) {
        //   baseUrl = this.$utils.getWindowNavUrl(2);
        //   url = `${baseUrl}/progress?sectionId=${itemData.Id}&pageMeta=${
        //     itemData.SubjectType == -1 ? 1 : itemData.SubjectType
        //   }`;
        // } else if (itemData.CourseType == 607) {
        //   baseUrl = this.$utils.getWindowNavUrl(4);
        //   url = `${baseUrl}?sectionId=${itemData.Id}&pageMeta=${
        //     itemData.SubjectType == -1 ? 1 : itemData.SubjectType
        //   }`;
        // }
        // let tempWindow = window.open("/loading", getRandom(999, 100));
        // let res = await setEncryption({
        //   token: this.$cookies.get("token")
        // });
        // console.log("url", url);
        // url = `${url}&restart=${restart}`;
      } else {
        // 判断登录弹窗
        return (this.$refs.header.$refs.login.logintc = true);
      }
      },
    },
  }
</script>

<style scoped lang="less">
  .search_tab {
    padding: 30px;
  }

  .search_tab .search_Text {
    height: 20px;
    font-weight: 400;
    font-size: 20px;
    color: #333333;
    line-height: 20px;
    text-align: left;
    margin-bottom: 50px;
    position: relative;
  }

  .search_tab .search_Text a {
    width: 123px;
    height: 25px;
    position: absolute;
    top: 13px;
    right: 0;
    background: url(../../assets/index/more.png) no-repeat;
    background-size: cover;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    line-height: 16px;
    text-align: center;
  }

  .search_tab_c span {
    display: inline-block;
    font-weight: 400;
    font-size: 26px;
    color: #333333;
    line-height: 26px;
    margin-right: 50px;
    cursor: pointer;
    font-weight: 400;
    transition: all .25s ease-in;
    -moz-transition: all .25s ease-in;
    -webkit-transition: all .25s ease-in;
  }

  .search_tab_c span:hover {
    font-weight: 500;
    color: #FF0659;
  }


  .search_tab_c span.side {
    font-weight: 500;
    color: #FF0659;
  }

  .main {
    padding-top: 20px;
    padding-bottom: 78px;
  }

  .search_con {
    font-weight: 400;
    font-size: 20px;
    color: #333333;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    margin-bottom: 30px;
  }

  .search_main {
    margin-bottom: 50px;
  }


  .KPTestsSection_main ul {
    margin-bottom: 30px;
  }


  .other_item {
    display: block;
    margin-right: 20px;
    margin-bottom: 30px;
    background-color: #fff;
    width: 285px;
    height: 150px;
    background: url(../../assets/practiceSystem/bj.png) no-repeat;
    background-size: 285px 150px;
    box-sizing: border-box;
    float: left;
    position: relative;
  }

  .other_item:nth-child(4n) {
    margin-right: 0;
  }

  .other_item .answer_box {
    position: absolute;
    top: 0;
    left: 0;
    width: 82px;
    height: 34px;
    text-align: center;
    line-height: 34px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }

  .other_item .answer_box .score_div {
    color: #337CFF;
    text-decoration: underline;
    cursor: pointer;
  }

  .other_item .name_box {
    position: absolute;
    top: 51px;
    left: 20px;
    width: 245px;
    height: 30px;
    background: #878DFF;
    border-radius: 16px 16px 16px 16px;
    font-weight: 500;
    font-size: 20px;
    color: #FFFFFF;
    line-height: 30px;
    text-align: left;
    text-indent: 10px;
  }

  .other_item .questions_count {
    position: absolute;
    top: 116px;
    left: 20px;
    display: flex;
    color: #333333;
  }

  .gray {
    color: #999999;
  }

  .other_item .btn_status_3 {
    position: absolute;
    top: 98px;
    left: 223px;
    width: 42px;
    height: 42px;
    cursor: pointer;
  }

  .other_item .btn_status_3 img {
    display: block;
    width: 42px;
    height: 42px;
  }

  .other_item .df_view {
    position: absolute;
    top: 104px;
    left: 75px;
    display: flex;
  }

  .other_item .df_view .btn_status {
    width: 90px;
    height: 32px;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 32px;
    text-indent: 27px;
    cursor: pointer;
  }

  .other_item .df_view .btn_status_1 {
    border-radius: 16px 16px 16px 16px;
    background: url(../../assets/practiceSystem/icon02.png) 3px #15CEB2 no-repeat;
    background-size: 24px 24px;
    margin-right: 10px;
  }

  .other_item .df_view .btn_status_2 {
    border-radius: 16px 16px 16px 16px;
    background: url(../../assets/practiceSystem/icon03.png) 3px #337CFF no-repeat;
    background-size: 24px 24px;
  }


  .block {
    width: 1180px;
    margin: 0 auto;
    text-align: right;
  }

  .search_null {
    width: 1180px;
    margin: 0 auto;
    text-align: center;
  }

  .search_null p {
    font-size: 12px;
    color: #333;
    line-height: 24px;
  }
  .cdk_modal_main {
  width: 800px;
  position: relative;
  text-align: center;
  .modal_close_icon {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 37px;
    height: 37px;
    cursor: pointer;
  }
  .modal_img {
    width: 375px;
    height: 330px;
  }
  .tips_modal {
    font-size: 24px;
    color: #333333;
    margin: 20px 0 40px;
  }
  .btn_modal {
    cursor: pointer;
    width: 160px;
    height: 42px;
    line-height: 42px;
    background: #ff0659;
    border-radius: 21px 21px 21px 21px;
    font-size: 20px;
    color: #ffffff;
    text-align: center;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/page2/search/search_Section.vue